import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { SpeakerRoom } from '@/components/SpeakerRoom';
import { ArrowLeft } from 'lucide-react';

export function SpeakerPage() {
  const { roomId } = useParams<{ roomId: string }>();
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleRoomCreated = (newRoomId: string) => {
    // Update URL to include room ID
    navigate(`/speaker/${newRoomId}`, { replace: true });
  };

  return (
    <div className="container mx-auto py-4">
      <Button 
        variant="outline" 
        onClick={handleBackToHome}
        className="mb-4"
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to Home
      </Button>
      <SpeakerRoom 
        roomId={roomId}
        onRoomCreated={handleRoomCreated}
      />
    </div>
  );
}